import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business プロジェクト管理フォルダの index。プロジェクト管理はサイドバーではフォルダ（遷移なし）だが、
 *  URL 直打ち等で /projects に来た場合は既定サブページの全体PJ看板へリダイレクトする
 * @graph-connects none
 */
export const Route = createFileRoute('/projects/')({
  beforeLoad: (): never => {
    throw redirect({ to: '/projects/all-pj-board' }) as unknown as Error;
  },
  component: () => null,
});
